// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"752":"e599668e","797":"9ec136eb","812":"6a28bd17","827":"bc0c1b0f","894":"681dbf02","973":"ae1316bd"}[chunkId] + ".chunk.js";
};